// One composer, two cards.
//
// The dashboard shows the composer and a live preview of what it will produce
// side by side, which only works if both are looking at the same thing. Rather
// than lifting a dozen pieces of state into the dashboard page and threading
// them down, the composer is created once here and read wherever it is needed.
//
// The full Compose screen does not use this: it is one card, so it calls the
// hook directly. The provider exists for the case where two components need the
// same instance, and for no other reason.

import { createContext, useContext, type ReactNode } from "react";
import { useComposer, type Composer } from "./useComposer";

const Ctx = createContext<Composer | null>(null);

export function ComposerProvider({ children }: { children: ReactNode }) {
  const composer = useComposer();
  return <Ctx.Provider value={composer}>{children}</Ctx.Provider>;
}

export function useSharedComposer(): Composer {
  const composer = useContext(Ctx);
  if (!composer) throw new Error("useSharedComposer must be used inside <ComposerProvider>");
  return composer;
}
